import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { media, notification } from 'ui';
import { isObjectNullOrEmpty } from '../../../utils/helpers';

const Message = styled.div`
  margin: 0 10px;
  width: 100%;
  ${media.tablet`
    margin: 0 0 10px;
  `};
`;

const LockMessage = ({ lock, type }) => {
  const [currentLock, setCurrentLock] = useState(lock);
  const intl = useIntl();

  useEffect(() => {
    setCurrentLock(lock);
  }, [lock]);

  const getMessage = () => {
    const { lockedReason, lockedByName, lockedOn, lockedByEmail } = currentLock;
    if (lockedReason === 'normal') {
      return intl.formatMessage(
        { id: 'lock.MESSAGE.NORMAL' },
        {
          name: lockedByName || lockedByEmail,
          date: `${intl.formatDate(lockedOn)} ${intl.formatTime(lockedOn)}`,
        },
      );
    }
    if (lockedReason === 'maintenance' || lockedReason === 'readonly') {
      return intl.formatMessage({ id: 'lock.MESSAGE.BUSY' }, { reason: lockedReason });
    }
    return intl.formatMessage(
      { id: 'lock.MESSAGE.GENERIC' },
      { date: `${intl.formatDate(lockedOn)} ${intl.formatTime(lockedOn)}` },
    );
  };

  if (currentLock && !isObjectNullOrEmpty(currentLock)) {
    if (type === 'notification') {
      notification.warning({
        message: getMessage(),
        placement: 'top',
      });

      return null;
    }
    return <Message>{getMessage()}</Message>;
  }

  return null;
};

LockMessage.propTypes = {
  lock: PropTypes.shape({
    id: PropTypes.string,
    lockedByEmail: PropTypes.string,
    lockedById: PropTypes.string,
    lockedByName: PropTypes.string,
    lockedOn: PropTypes.string,
    lockedReason: PropTypes.string,
    type: PropTypes.string,
  }),
  type: PropTypes.string,
};

export default LockMessage;
